import React from 'react';
import { GET_COMPLETED_RECEIVED_REFERRALS } from '../gql';
import { REFERRAL_RECEIVER_SUBSCRIPTION } from '../../referral/gql/Subscription';
import { Stack } from '@mui/material';
import DateTimeUtils from '../../common/services/DateTimeUtils';
import { MyTypography } from '../../common/components';
import CompletedReferrals from './common/CompletedReferrals';
import ActiveReferralActionsCell from '../tables/components/ActiveReferralActionsCell';

const columns = [
  {
    field: 'patient',
    headerName: 'Patient Name',
    width: 180,
    valueGetter: params => {
      return params.row.referral.getFullName();
    },
  },
  {
    field: 'referrer',
    headerName: 'Referral Source',
    width: 250,
    valueGetter: params => {
      return params.row.referral.getReferrerClinic();
    },
    renderCell: params => {
      return (
        <Stack direction="column" spacing={1}>
          <MyTypography variant="h5" component="h5" color="text.primary" style={{ 'margin': '0' }}>
            {params.row.referral.getReferrerClinic()}
          </MyTypography>
          {params.row.referral.getReferrerClinic().includes('★') ? (<MyTypography variant="h6" component="h6" color="text.primary" style={{ 'fontStyle': 'italic', 'margin': '0' }}>
            {(params.row.referral.getReferrerClinic() !== '★ Referral From Fax') ? 'Submitted via Public Form' : ''}
          </MyTypography>) : null}

        </Stack>
      );
    },
  },
  {
    field: 'provider',
    headerName: 'Provider',
    width: 160,
    valueGetter: params => {
      return params.row.referral.getProviderName();
    },
  },
  {
    field: 'actions',
    headerName: 'Actions',
    width: 150,
    headerAlign: 'center',
    sortable: false,
    editable: false,
    filterable: false,
    disableColumnMenu: true,
    align: 'center',
    renderCell: (params) => <ActiveReferralActionsCell row={params.row} type="received" completed={true}/>
  },
  {
    field: 'appointment_maintained',
    headerName: 'Maintained Appointment',
    width: 200,
    valueGetter: params => {
      return params.row.referral.isMaintainedAppointment();
    },
    renderCell: (params) => (
      <div style={{
        display: '-webkit-box',
        WebkitBoxOrient: 'vertical',
        WebkitLineClamp: 2,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        width: '100%',
      }} title={params.value}>
        {params.value}
      </div>
    ),
  },
  {
    field: 'appointments',
    headerName: 'Appointment Date',
    width: 200,
    valueGetter: params => {
      return params.row.referral.getDateOrReason();
    },
  },
  {
    field: 'accepted_at',
    headerName: 'Date Received',
    width: 250,
    valueGetter: params => {
      return params.row.referral.receivedFormattedDate();
    },
    sortComparator: DateTimeUtils.dateSortComparator
  },
  {
    field: 'updated_by',
    headerName: 'Last Updated By',
    width: 250,
    valueGetter: params => {
      return params.row.referral.getLastUpdatedByFullName();
    },
  },
  {
    field: 'updated_at',
    headerName: 'Last Updated At',
    width: 250,
    valueGetter: params => {
      return params.row.referral.formattedDate();
    },
    sortComparator: DateTimeUtils.dateSortComparator
  },
];

export default function CompletedReceivedReferrals({ uuid, onViewLogs, onView }) {
  return (
    <CompletedReferrals
      query={GET_COMPLETED_RECEIVED_REFERRALS}
      uuid={uuid}
      subscription={REFERRAL_RECEIVER_SUBSCRIPTION}
      onViewLogs={onViewLogs}
      onView={onView}
      columns={columns}
      showAppointmentFilter={false}
    />
  );
}
